// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"284":"statistics-designer","349":"statistics-viewer","370":"UIEditor","901":"MonacoExpressionBuilder"}[chunkId] || chunkId) + "." + {"284":"1205dd76","349":"1205dd76","370":"2dfc29f6","625":"cf78b3d4","901":"e79414a9"}[chunkId] + ".chunk.css";
};